import getSymbolFromCurrency from 'currency-symbol-map';

export const toCurrencyAmount = (amount: number, currency: string) => {
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const symb = getSymbolFromCurrency(currency) ?? '';

  return `${symb}${safeAmount}`;
};
